import createAxiosInstance, { setAuthToken } from "../axios/axiosCustom"
import { setStoreData } from "./setStoreData"


let I = 0
async function initializeStates(accToken, refreshToken, dispatch, state) {
  const pathname = window.location.pathname
  const axiosCustom = await createAxiosInstance()

  const user = await axiosCustom.get('/getUser')
  if(!user) {
    I++
    setNewAccToken(refreshToken)
    if(I < 3) {
      initializeStates(accToken, refreshToken)
    } 

    return
  }

  dispatch({ type: 'USER_LOGIN', payload: user.data })
  dispatch({ type: 'ACCESS_TOKEN', payload: accToken })
  await setStoreData(dispatch)
}

// function for when acc token expires
const setNewAccToken = async (refreshToken) => {
  const axiosCustom = await createAxiosInstance()

  let resp = await axiosCustom.post('/token', { refreshToken: refreshToken})
  let accToken = resp.data.accessToken
  let bearerAccessToken = 'Bearer ' + accToken

  setAuthToken(bearerAccessToken)
}


export default initializeStates;